import React from 'react';
import { Block, Row, Tooltip } from '@upsales/components';
import { PrimaryButton, DefaultButton, ThirdButton } from '@upsales/components/Buttons';
import T from 'Components/Helpers/translate';
import history from 'App/pages/routes/history';
import openModal from 'App/services/Modal';
import { hasSoftDeployAccess } from 'App/services/FeatureHelperStandalone';

/**
 * Find similar's two ways in, for an account on the V2 prospecting workspace
 * (WEB-11024): the similarity model's list, or a prospecting agent session
 * seeded with "find companies similar to X". The agent still has an answer for
 * a company the model has no matches for, so that case leaves only the model's
 * option disabled.
 *
 * Shared by the React and the Angular company card. Without the flag the card
 * runs the similarity model straight away, as it always has.
 */
export const canChooseFindSimilar = () => hasSoftDeployAccess('PROSPECTING_AGENT_V2');

type Options = {
	client: { id: number; name: string };
	onSimilarityModel: () => void;
	/** The model was already asked for this company and had nothing. */
	similarityModelEmpty?: boolean;
};

const openFindSimilarChoice = ({ client, onSimilarityModel, similarityModelEmpty = false }: Options) =>
	openModal('Alert', {
		title: 'account.findSimilar.choice.title',
		body: T('account.findSimilar.choice.body', { name: client.name }),
		alertType: 'info',
		hideConfirm: true,
		hideAbort: true,
		customControls: (close: (confirmed?: boolean) => void) => (
			<Row align="right">
				<Block space="mrl">
					<PrimaryButton
						onClick={() => {
							close();
							history.push(`/prospecting-workspace?similarTo=${client.id}`);
						}}
					>
						{T('account.findSimilar.choice.agent')}
					</PrimaryButton>
				</Block>
				<Block space="mrl">
					<Tooltip title={T('account.findSimilar.noMatchesFound')} disabled={!similarityModelEmpty}>
						<DefaultButton
							disabled={similarityModelEmpty}
							onClick={() => {
								close();
								onSimilarityModel();
							}}
						>
							{T('account.findSimilar.choice.similarityModel')}
						</DefaultButton>
					</Tooltip>
				</Block>
				<Block>
					<ThirdButton onClick={() => close()}>{T('alertModal.cancel')}</ThirdButton>
				</Block>
			</Row>
		)
	});

export default openFindSimilarChoice;
